import React from "react";
import Avatar from "../../../../../components/Avatar";
import { Grid, Tooltip } from "@mui/material";
import CustomizedProgressBars from "../../../../board/components/progressBar/ProgressBar";
import { createAvatarName, SanitizedHtml } from "../../../../../utils";
import { useFeedActorMeta } from "../hooks/useFeedActorMeta";
import { useFeedBoardMeta } from "../hooks/useFeedBoardMeta";

function ShowWorklog({ worklog, boardName }) {
  const { actor, avatarStyles, formattedDate, isMobile } = useFeedActorMeta({
    user: {
      username: worklog?.username,
      user_image: worklog?.user_image,
      profile_color: worklog?.user_profile_color,
    },
    date: worklog?.created_at,
    desktopFormat: "MMMM D, YYYY [at] h:mm A",
  });
  const { boardKeyDisplay, boardName: boardTitle, openBoard, openCard } =
    useFeedBoardMeta(boardName, worklog?.card_id);

  if (!worklog) return null;

  return (
    <Grid
      container
      spacing={2}
      sx={{
        width: isMobile
          ? "calc(100% - 10px) !important"
          : "calc(100% + 16px) !important",
      }}
      className="worklog-item d-flex justify-content-space-between">
      <Grid
        item
        xs={isMobile ? 12 : 9}
        sx={{ paddingLeft: isMobile && "8px !important" }}>
        <div className="d-flex w-100">
          <Avatar
            // key={`user-avtar-${el.user_id}`}
            username={`${worklog?.username}`}
            user_image={actor.userImage}
            title={actor.username}
            className="user-avtar-dropdown user-avatar mr-8"
            style={avatarStyles}>
            {createAvatarName(actor.username || "")}
          </Avatar>
          <div className="w-100">
            <div className="d-flex justify-content-space-between ">
              <div
                className={
                  isMobile
                    ? "d-flex align-items-center flex-dir-col"
                    : "d-flex align-items-center"
                }>
                <div>
                  <Tooltip title={boardTitle}>
                    <a
                      className="board-anquor cursor-pointer underline"
                      onClick={openBoard}>
                      {boardKeyDisplay}
                    </a>
                  </Tooltip>
                  -
                  <a
                    className="board-anquor cursor-pointer mr-1 underline"
                    onClick={openCard}>
                    {worklog?.card_id}:
                  </a>
                </div>
                <p className="worklog-title mr-2">{actor.username}</p>
              </div>
              <p className="hours">{worklog?.hour_spent} Hours</p>
            </div>
            <SanitizedHtml
              as="div"
              className="worklog-worklog comment-content"
              html={worklog?.history_text}
            />
            <SanitizedHtml
              as="div"
              className="worklog-worklog"
              html={worklog?.work_performed}
            />
          </div>
        </div>
      </Grid>
      <Grid
        item
        xs={isMobile ? 12 : 3}
        sx={{ paddingTop: isMobile && "0px !important" }}>
        <div className={isMobile ? "" : "right-details"}>
          <div className="d-flex justify-content-end">
            <p className="worklog-status">{worklog?.workflow_step}</p>
          </div>
          <p
            className="worklog-date-time"
            style={{ marginTop: isMobile && "4px" }}>
            {formattedDate}
          </p>
          <CustomizedProgressBars
            allocatedHours={worklog?.allocated_hours}
            hoursSpent={worklog?.response_object?.new_key?.total_hour_spent}
          />
        </div>
      </Grid>
    </Grid>
  );
}

const isChangeFeedWorklog = (prevProps, nextProps) => {
  return (
    prevProps.worklog.card_id === nextProps.worklog.card_id &&
    prevProps.worklog.username === nextProps.worklog.username &&
    prevProps.worklog.hour_spent === nextProps.worklog.hour_spent &&
    prevProps.worklog.workflow_step === nextProps.worklog.workflow_step &&
    prevProps.worklog.work_performed === nextProps.worklog.work_performed &&
    prevProps.worklog.allocated_hours === nextProps.worklog.allocated_hours
  );
};
export default React.memo(ShowWorklog, isChangeFeedWorklog);
